import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/plus-circle-line.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

export const PlusCircleLine = withSvgProps(Svg)
